var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"counter",on:{"click":function($event){return _vm.$refs.commentsModal.open()}}},[_c('CommentIcon'),_vm._v("  "+_vm._s(_vm.$formatNum(_vm.commentCount))+" ")],1),_c('Modal',{ref:"commentsModal"},[_c('Comments',{attrs:{"round":_vm.post},on:{"commentAdded":function($event){_vm.commentCount += 1}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }